module.exports = __webpack_public_path__ + "assets/images/discord-logo-small-2c21aeda16de354ba5334551a883b481.png";